/* eslint-disable */
import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';
import useMenuItems from './useMenuItems';
import _ from 'lodash';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { isSelectedFiltersObjectEmpty } from 'components/FilterMenus/FilterMenus.service';
import { PM_PROVIDERS } from 'common/constants/constants';

const StyledFiltersContainer = styled.div`
  & ${Text} {
    margin: 1rem 0 1rem 0.25rem;
    font-size: 1.2rem;
    font-weight: bold;
  }
`;

const MAX_CONDITIONS = 7;

export const CfrMttrFilterSelector = ({
  selectedFilters = [],
  // @ts-check
  isLoadingFilters,
  onAddFiltersSelector = _.noop,
  metricName,
  updateFiltersAtIndex = _.noop,
  removeCondition,
  pmProvider
}) => {
  const { customFieldsMapper, menuItemsV2 } = useMenuItems();

  const supportAllFieldsConditionByProvider = {
    [PM_PROVIDERS.JIRA]: true,
    [PM_PROVIDERS.AZURE_BOARDS]: false
  };

  return (
    <>
      {selectedFilters.map((filters, idx) => {
        return (
          <StyledFiltersContainer>
            <FilterMenusV2
              customFieldById={true}
              menuItems={menuItemsV2}
              supportAllFields={supportAllFieldsConditionByProvider[pmProvider]}
              customFieldsMapper={customFieldsMapper}
              selectedFilters={filters}
              setSelectedFilters={selectedFilters => {
                isSelectedFiltersObjectEmpty(selectedFilters)
                  ? removeCondition(idx)
                  : updateFiltersAtIndex(idx, selectedFilters);
              }}
              btnClearFiltersTitle='Clear Rule'
              buttonTitle='Add Rule'
              onClearFilters={() => removeCondition(idx)}
              isLoading={isLoadingFilters}
              documentIdPrefix={`${metricName}-${idx.toString()}`}
            />
            {idx < MAX_CONDITIONS - 1 && <Text>OR</Text>}
          </StyledFiltersContainer>
        );
      })}
      {(selectedFilters.length < MAX_CONDITIONS ||
        selectedFilters.length === 0) && (
        <FilterMenusV2
          customFieldById={true}
          menuItems={menuItemsV2}
          supportAllFields
          customFieldsMapper={customFieldsMapper}
          selectedFilters={{}}
          setSelectedFilters={selectedFilters => {
            onAddFiltersSelector(selectedFilters);
          }}
          buttonTitle='Add Condition'
          isLoading={isLoadingFilters}
          documentIdPrefix={`${metricName}-${selectedFilters.length}`}
        />
      )}
    </>
  );
};
